<template>
  <ion-app>
    <ion-content>
      <v-container fluid id="admin">
        <div class="van-hairline--bottom van-nav-bar" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
          <div class="van-ellipsis van-nav-bar__title">{{ $t("admin.title") }}</div>
        </div>

        <div class="background_color_ffffff">
          <v-row justify="center" class="index_head padding_10">
            <v-col cols="10" sm="10" class="font_12">
              <wc-search-box :placeholder="$t('admin.search')" @input="onClickSearch" />
              <br />
            </v-col>
            <!-- <v-col cols="2"> -->
            <!-- <v-checkbox v-model="onHoldOnly" label="On hold only"></v-checkbox> -->
            <!-- </v-col> -->
          </v-row>
        </div>

        <div class="pa-5">
          <v-data-iterator :items="memberList" :items-per-page="itemsPerPage" :page.sync="pageNo" hide-default-footer
            class="d-flex flex-column overflow-hidden">
            <template v-slot:no-data>
              <div>Search for members by Email, or by name.</div>
            </template>

            <template v-slot:default="props">
              <v-card xoutlined v-for="item in props.items" :key="item.MemberId">
                <v-row class="text-caption text-sm-body-2 text-md-body-1" align="center">
                  <v-col cols="5" sm="5" md="4">{{ item.eMailAddress }}</v-col>
                  <v-col cols="4" sm="4" md="3">{{ item.Name }}</v-col>
                  <v-col cols="3" sm="3" md="3">{{ item.Phone }}</v-col>
                  <v-col cols="3" sm="3" md="2">
                    <v-btn color="warning" @click="onClickResetMember(item.MemberId)" v-show="item.OnHold">Reset</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </template>

            <template v-slot:footer v-if="numberOfPages > 1">
              <wc-list-footer v-model="pageNo" :maxPage="numberOfPages" />
              <!-- <v-row class="no-gutters mt-auto py-2 shrink" align="center" justify="center">
                <span class="mr-4 grey--text">
                  Page <span v-text="pageNo" class="font-weight-bold primary--text"></span> of {{ numberOfPages }}
                </span>
                <v-btn small dark rounded color="blue darken-3" class="mr-1" v-show="pageNo > 1" @click="prevPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small dark rounded color="grey" class="mr-1" v-show="pageNo <= 1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small dark rounded color="blue darken-3" class="ml-1" v-show="pageNo < numberOfPages" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn small dark rounded color="grey" class="ml-1" v-show="pageNo >= numberOfPages">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row> -->
            </template>
          </v-data-iterator>
        </div>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      onHoldOnly: true,
      searchText: "",
      curMember: null,
      memberList: [],

      pageNo: 1,
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    // cols="4" sm="3" md="2"
    itemsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 99;
        case "sm":
          return 99;
        case "md":
          return 3 * 4;
        case "lg":
          return 3 * 6;
        case "xl":
          return 3 * 6;
      }
    },
    numberOfPages() {
      return Math.ceil(this.memberList.length / this.itemsPerPage);
    },
  },
  mounted() {
    if (this.member.AdminRole) {
    } else {
      this.$router.push({ name: "home" });
    }
  },
  methods: {
    // ------------------------------------------------------------------------ nextPage
    nextPage() {
      if (this.pageNo < this.numberOfPages) {
        this.pageNo += 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ prevPage
    prevPage() {
      if (this.pageNo > 1) {
        this.pageNo -= 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ onClickSearch
    onClickSearch(data) {
      this.searchText = data;
      this.getMemberList();
    },
    // ------------------------------------------------------------------------ getBrandList
    getMemberList() {
      this.MemberList = [];
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        searchText: this.searchText,
      };
      this.$ajax2
        .post("SearchMember", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.memberList = rpdata.data.data;
          }
        }).catch(function (err) { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickResetMember
    onClickResetMember(memberId) {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        MemberId: memberId,
      };
      this.$ajax2
        .post("ResetMember", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            alert("reset successful");
            this.getMemberList();
          }
        }).catch(function (err) { }); // eslint-disable-line
    },
  },
};
</script>

<style>
#brandList {
  width: 100%;
}

#brandList .brand_info {
  max-height: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  text-align: center;
  padding: 0px;
}

#brandList .brand_info .brand_title {
  font-size: 10px;
  text-align: center;
  width: 100%;
}

/* #brandList .brand_info .brand_image {
  border: 1px solid black;
} */
#brandList .brand_info .brand_image img {
  display: block;
  max-height: 100%;
  max-width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

/*
.brand_image {
  position: relative;
  width: 100%;
  vertical-align: middle;
}
.brand_image:before {
  content: "";
  display: block;
  padding-top: 80%;
}
.brand_image img {
  position: absolute;
  top: 5%;
  left: 5%;
  bottom: 0%;
  right: 0%;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
}
*/

/*
#brandList .van-col--9 {
  width: 33%;
}
#brandList .van-hairline--top-bottom::after {
  border-width: 0;
}
*/
/* #brandList .index_head {
  margin-left: 16px !important;
  margin-right: 0px !important;
  height: 44px;
} */
</style>
